import { getLayoutPath } from './getLayoutPath';
import { usePathname } from './pathname';

export const useLayoutPath = () => {
    const layoutPath = usePathname();

    return getLayoutPath(layoutPath);
};
